<template>
  <section class="section">
    <div class="container is-fluid">
      <h1 class="title is-1">Pictures</h1>

      <section
        v-if="loading"
        class="loading-section"
      >
        <b-loading
          :is-full-page="false"
          :active.sync="loading"
          :can-cancel="true"
        ></b-loading>
      </section>

      <div v-else-if="hasPictures">
        <div class="columns is-multiline is-centered">
          <div
            class="column is-one-third"
            v-for="(picture, idx) in pictures"
            :key="picture.id"
          >
            <transition
              enter-active-class="animated fade-in"
              mode="out-in"
              leave-active-class="animated fade-out"
            >
              <figure class="image">
                <img
                  v-lazy="picture.image"
                  :alt="picture.name"
                  @click="imageIndex = idx"
                >
              </figure>
            </transition>
          </div>
        </div>
        <vue-gallery-slideshow
          :images="imageLinks"
          :index="imageIndex"
          @close="imageIndex = null"
        />
        <div
          v-if="paginate"
          class="columns is-multiline is-centered"
        >
          <div
            @click="getPictures(false)"
            class="column is-one-third"
          >
            <b-pagination
              :total="pictureCount"
              :current.sync="currentPage"
              :order="'is-centered'"
              :size="'is-small'"
              :rounded="true"
              :per-page="perPage"
            ></b-pagination>
          </div>
        </div>
      </div>
      <div v-else>
        <p>
          There are no pictures yet. Check back later.
        </p>
      </div>
    </div>
  </section>
</template>

<script>
import _ from 'lodash';
import VueGallerySlideshow from 'vue-gallery-slideshow';

import PicturesAPI from '@/services/api/Pictures';

export default {
  name: 'PicturesPage',
  components: { VueGallerySlideshow, },
  data() {
    return {
      loading: true,
      pictures: [],
      pictureCount: 0,
      perPage: 12,
      currentPage: this.$route.query.page || 1,
      hasPictures: false,
      paginate: false,
      imageIndex: null,
    };
  },
  mounted() {
    this.getPictures();
  },
  methods: {
    getPictures(load) {
      if (load) {
        this.loading = true;
      }
      PicturesAPI.getAllPictures(this.currentPage)
        .then(pictures => {
          this.pictures = pictures.results;
          this.imageLinks = pictures.results.map(picture => picture.image);
          this.pictureCount = pictures.count;
          this.hasPictures = pictures.count > 0;
          this.paginate = this.pictureCount > this.perPage;
        })
        .catch(error => {
          if (error.detail === 'Invalid page.') {
            this.$router.go(-1);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.loading-section {
  height: 1000px;
}
</style>
